import { x25519 } from '@noble/curves/ed25519';
import { encodeBase64Url, decodeBase64Url } from './primitives';
import { persistVaultPlaintext } from './vaultPersist';

const REPLY_PRIV_KEY = 'shareweb:infoReplyPriv:';

function storeReplyPrivateKey(shareId: string, privateKey: Uint8Array): void {
  sessionStorage.setItem(`${REPLY_PRIV_KEY}${shareId}`, encodeBase64Url(privateKey));
}

export function generateInfoShareReplyKeyPair(): { privateKey: Uint8Array; publicKey: Uint8Array } {
  const privateKey = x25519.utils.randomPrivateKey();
  return { privateKey, publicKey: x25519.getPublicKey(privateKey) };
}

export async function persistInfoShareReplyPrivateKey(
  shareId: string,
  privateKey: Uint8Array,
  userId: string,
): Promise<void> {
  const encoded = encodeBase64Url(privateKey);
  storeReplyPrivateKey(shareId, privateKey);

  await persistVaultPlaintext(userId, (plaintext) => ({
    ...plaintext,
    infoReplyPriv: {
      ...(plaintext.infoReplyPriv ?? {}),
      [shareId]: encoded,
    },
  }));
}

export function createInfoShareReplyKeys(shareId: string): Uint8Array {
  const { privateKey, publicKey } = generateInfoShareReplyKeyPair();
  storeReplyPrivateKey(shareId, privateKey);
  return publicKey;
}

export async function createAndPersistInfoShareReplyKeys(
  shareId: string,
  userId: string,
): Promise<Uint8Array> {
  const { privateKey, publicKey } = generateInfoShareReplyKeyPair();
  await persistInfoShareReplyPrivateKey(shareId, privateKey, userId);
  return publicKey;
}

export function getStoredInfoShareReplyPrivateKey(shareId: string): Uint8Array | null {
  const stored = sessionStorage.getItem(`${REPLY_PRIV_KEY}${shareId}`);
  if (!stored) {
    return null;
  }

  try {
    return decodeBase64Url(stored);
  } catch {
    return null;
  }
}
